module.exports = __webpack_public_path__ + "img/aadt.96e74aa2.jpeg";